import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BizObjectParameters } from './biz-object-parameters';

@Injectable({
  providedIn: 'root',
})
export class BizObjectParametersService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return 'api/biz-object-parameters';
  }


  /**
   * 通过key查找
   * @param key
   */
  getByKey(key: String): Observable<BizObjectParameters> {
    const url = `${this.getUrl()}/key/${key}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object key=${key}`)),
      catchError(this.handleError<any>(`get any key=${key}`)),
    );
  }


}
